import { Notifications } from "@jds/core";
import { useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
const useApiHttp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isRefreshTokenLoading, setIsRefreshTokenLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState(null);

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const baseAuth = process.env.REACT_APP_BASE_AUTH;
  const baseAuthV2 = process.env.REACT_APP_BASE_AUTHV2;
  const baseMedia = process.env.REACT_APP_BASE_MEDIA;
  const AdminbearerToken = localStorage.getItem("authToken");

  const loginDetails = useSelector((state) => state.auth.loginDetails);
  const isJitoUser = loginDetails?.userType === "JITO";
  const eventJWT = localStorage.getItem("eventJWT");
  const userRole = localStorage.getItem("userRole");
  const isGuest = userRole === "GUEST";
  const navigate = useNavigate();

  const sendRequest = useCallback(
    async (
      requestConfig,
      applyData = null,
      onSuccess = null,
      onError = null,
      res = null,
    ) => {
      setIsLoading(true);
      setSuccess(null);
      setError(null);

      let responseData = null;
      let url = baseUrl + requestConfig.url;
      switch (requestConfig.base) {
        case "AUTH":
          url = baseAuth + requestConfig.url;
          break;
        case "AUTHV2":
          url = baseAuthV2 + requestConfig.url;
          break;
        case "MEDIA":
          url = baseMedia + requestConfig.url;
          break;
      }
      if (requestConfig.absoluteUrl) {
        url = requestConfig.url;
      }
      const isBearer = requestConfig?.isBearer == false ? false : true;

      let headers = {};
      console.log(requestConfig?.headers)
      headers.cookie = "name=sam";
      if (AdminbearerToken && isBearer)
        headers.Authorization = `Bearer ${AdminbearerToken}`;
      if (!requestConfig.formData && !requestConfig?.headers) headers["content-type"] = "application/json";
      if (requestConfig?.packageName)
        headers["event_package_name"] = requestConfig?.packageName;
      if (requestConfig?.requestId) {
        headers.requestId = requestConfig.requestId;
      }
      if (requestConfig.headers) {
        headers = { ...headers, ...requestConfig.headers }
      }

      // debugger;
      try {
        const response = await fetch(url, {
          method: requestConfig.method ? requestConfig.method : "GET",
          // headers: requestConfig.formData
          //   ? {
          //       Authorization: `Bearer ${AdminbearerToken}`,
          //     }
          //   : AdminbearerToken && isBearer
          //   ? {
          //       Authorization: `Bearer ${AdminbearerToken}`,
          //       "Content-Type": "application/json",
          //     }
          //   : {
          //       "Content-Type": "application/json",
          //     },
          headers,
          body: requestConfig.formData
            ? requestConfig.body
            : requestConfig?.binary
              ? requestConfig.body
              : JSON.stringify(requestConfig.body),
          signal: requestConfig.signal || null,
        });

        if (response.status === 204) {
          setIsSuccess(true);
          onSuccess && onSuccess(); // Call onSuccess callback with response data
        }

        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
          responseData = await response.json();
        } else {
          responseData = await response.blob();
        }
        applyData && responseData && applyData(responseData);
        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204 ||
          response.status === 202
        ) {
          setSuccess(responseData.message);
          setIsSuccess(true);
          onSuccess && onSuccess(responseData, response); // Call onSuccess callback with response data
        }
        if (response.status !== 200 && response.status !== 201) {
          if (response.status === 409) {
            // navigate("/auth/signin");
            window.location.href = process.env.REACT_APP_JIOCLOUD_HOME_URL;
            localStorage.clear();
          } else {
            throw {
              err: true,
              statusCode: responseData.statusCode,
              message: responseData.message,
              data: responseData,
              wasAborted: false,
            };
          }
        }
      } catch (err) {
        setError(err.message || "Something went wrong!");

        const refreshToken = localStorage.refreshToken;
        const refreshTokenAPI = async (responseData = null) => {
          localStorage.isRefreshTokenLoading = true;
          try {
            const response = await fetch(`${baseAuth}user/refresh-token`, {
              method: "POST",
              headers: {
                // Authorization: `Bearer ${refreshToken}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ refreshToken }),
            });
            console.log(response);
            const refreshResponseData = await response.json();
            console.log(refreshResponseData);

            if (refreshResponseData.statusCode === 200) {
              localStorage.authToken = refreshResponseData.data.accessToken;
              localStorage.refreshToken = refreshResponseData.data.refreshToken;
              if (!requestConfig?.noRefresh) {
                window.location.reload();
              }

              setTimeout(() => {
                console.log("requestconfig==>", requestConfig);

                console.log("Refresh123 Token delay");
                onError &&
                  onError(err, {
                    ...responseData,
                    message: "Please try again!",
                  });
              }, 5000);
            }

            if (refreshResponseData.statusCode !== 200) {
              // throw new Error(responseData);
              // navigate("/auth/signin");
              window.location.href = process.env.REACT_APP_JIOCLOUD_HOME_URL;
              localStorage.clear();
            }
          } catch (error) {
            console.log(error);
          }
          localStorage.removeItem("isRefreshTokenLoading");
        };

        if (responseData) {
          if (
            responseData.statusCode === 1001 ||
            responseData.statusCode === 1002
          ) {
            console.log("hello1123==>user", localStorage.isRefreshTokenLoading);
            if (localStorage.isRefreshTokenLoading !== "true") {
              refreshTokenAPI(responseData);
            }
          } else {
            if (
              responseData.statusCode === 401 ||
              responseData.statusCode === 1003 ||
              responseData.statusCode === 1004
            ) {
              Notifications.toast.error({
                id: "refres-token_error",
                title: "Your session has expired",
              });
              // navigate("/auth/signin");

              if (isJitoUser) {
                window.location.href = `${process.env.REACT_APP_JIOCLOUD_LANDING_URL}/signin?id=jitoorg&eventJWT=${eventJWT}`;
              } else if (eventJWT && isGuest) {
                window.location.href = `${process.env.REACT_APP_JIOCLOUD_LANDING_URL}/webview?id=JITOGUEST&eventJWT=${eventJWT}`;
              } else {
                window.location.href = process.env.REACT_APP_JIOCLOUD_HOME_URL;
              }
              localStorage.clear();
            } else {
              onError
                ? onError(err, responseData)
                : Notifications.toast.error(
                    responseData.statusCode !== 400
                      ? "Something went wrong"
                      : responseData.message,
                  ); // Call onError callback with error object
            }
          }
        } else {
          onError && onError(err);
        }

        // Call onError callback with error object
        // Notifications.toast.error(err.response.data.error);
      }
      setIsLoading(false);
    },
    [AdminbearerToken],
  );

  return {
    isLoading,
    success,
    isSuccess,
    error,
    sendRequest,
  };
};

export default useApiHttp;
